import HealthInsuranceRoutes from './routes/HealthInsuranceRoutes';

function App() {
  return (
    <HealthInsuranceRoutes />
  );
}

export default App;
